<template lang="pug">
  .layout
    y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(flat)
        template(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-col(align="center")
              v-progress-circular.ma-auto(:width="3" :size="30" color="info500" indeterminate)
              div.s1.primary--text.text-center.mt-6 {{ $t('arranging_shipment') }}
              div.p2.primary--text.text-center.mt-1 {{ $t('please_do_not_refresh') }}

        template(v-else-if="arrangeSuccessful")
          v-card.pa-4(flat v-if="yezzaShipping.fulfilment")
            div.h6.primary500--text {{ $t('arrangement_successful') }}
            v-card-text(ref="container")
              div.mt-6(align="center")
                v-img(:src="require('@/assets/images/bg_arrange_successful.png')" eager contain max-height="120")
                div.p1.primary--text.mt-4 {{ $t('your_delivery_are_shown', { id: lead.rid }) }}
              div.mt-6(style="border:1px solid var(--v-basic400); border-radius: 4px;")
                div.pa-4
                  div.s2.basic700--text {{ arrangedShipping.meta_data.receiver_name | capitalize }}
                  .address(v-if="arrangedShipping.meta_data.receiver_address")
                    div.p2.basic700--text(v-if="yezzaShipping.fulfilment.meta_data.shipping_type === 'courier'") {{ arrangedShipping.meta_data.receiver_address.city }}, {{ arrangedShipping.meta_data.receiver_address.state }}
                    div.p2.basic700--text(v-else) {{ arrangedShipping.meta_data.receiver_address.address_1 }}, {{ arrangedShipping.meta_data.receiver_address.address_2 }}, {{ arrangedShipping.meta_data.receiver_address.city }}, {{ arrangedShipping.meta_data.receiver_address.state }}
                v-divider.basic400
                div.d-flex.align-center.pa-4
                  div(style="width: 72px" align="center")
                    v-img(:src="yezzaShipping.fulfilment.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                  div.pl-2(v-if="yezzaShipping.fulfilment.meta_data.shipping_type === 'courier'")
                    div.p2.basic700--text {{ arrangedShipping.meta_data.service_type | capitalize}} | {{ arrangedShipping.meta_data.sending_date | humanizeDate }}
                    div.p2.basic700--text {{ arrangedShipping.meta_data.tracking_no }}
                  div.pl-2(v-else)
                    div.p2.basic700--text Pick up | {{ arrangedShipping.meta_data.service_type | capitalize }}
                    div.p2.basic700--text.text-capitalize {{ arrangedShipping.meta_data.sending_date | convertServerDate }}
                    div.p2.basic600--text.text-capitalize {{ $t('refer_link_real_time') }}
                v-divider.basic400
                div.pa-4
                  template(v-if="yezzaShipping.fulfilment.meta_data.shipping_type === 'courier'")
                    div
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingNo" v-clipboard:copy="arrangedShipping.meta_data.tracking_no")
                        eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('copy_tracking_no') }}
                    div.mt-4
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="shareToWA(arrangedShipping.meta_data.tracking_no)")
                        v-icon(color="info500" size="16") mdi-whatsapp
                        div.info500--text.ml-2 {{ $t('share_tracking_customer') }}
                    div.mt-4
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="clickDownloadAWB(arrangedShipping.meta_data.awb_link)")
                        eva-icon.mb-n1(name="download-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('download_air_waybill') }}
                  template(v-else-if="arrangedShipping.meta_data.tracking_no")
                    div
                      v-btn.button-Aa-small.px-0(text color="transparent" small @click="copyTrackingLink" v-clipboard:copy="arrangedShipping.meta_data.tracking_no")
                        eva-icon.mb-n1(name="copy-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('copy_tracking_link') }}
                    div.mt-4
                      v-btn.button-Aa-small.px-0.mt-4(text color="transparent" small @click="shareTrackingLinkToWA(yezzaShipping.fulfilment.meta_data.shipping_name, arrangedShipping.meta_data.tracking_no)")
                        v-icon(color="info500" size="16") mdi-whatsapp
                        div.info500--text.ml-2 {{ $t('share_tracking_customer') }}
                    div.mt-4
                      v-btn.button-Aa-small.px-0.mt-4(text color="transparent" small @click="openTrackingLink")
                        eva-icon.mb-n1(name="map-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].info500")
                        div.info500--text.ml-2 {{ $t('view_real_time_tracking') }}
                  template(v-else)
                    div.c1.basic600--text {{ $t('tracking_data_not_ready') }}

                v-divider.basic400
                div.pa-4
                  div.c1.basic600--text {{ $t('ref_id') }}: {{ arrangedShipping.ref_id }}
                  div.c1.basic600--text {{ $t('arranged_on') }} {{ displayArrangeOnDate(arrangedShipping.submitted_on) }}
              
              div.mt-6(align="right")
                v-btn.button-AA-medium(color="info500" depressed dark height="40" @click="finishArranging")
                  div.mx-2.text-uppercase {{ $t('finish') }}

              div.mt-6
                iframe(:src="typeFormRateUrl" :width="containerWidth" height="500px" frameborder="0")

        template(v-else-if="arrangingRider")
          v-card.pa-4(flat)
            v-card-title.pa-0
              v-btn(text icon small @click="closeDialog")
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary700" width="22" height="22")
            v-card-text.d-flex.justify-center.align-center(style="height:80vh")
              div.mt-6(align="center")
                v-progress-circular.mb-10(:width="6" :size="45" color="info500" indeterminate)
                div.s1.mb-2 {{ $t('finding_rider') }}
                div.p2.mb-10 {{ $t('hold_on') }}
                v-btn.mb-10(small outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" @click="hasOtherOngoingData ? openOngoingDialog() : closeAllDialogs()")
                  .button-AA-small.primary500--text {{ hasOtherOngoingData ? $t('view_all_ongoing_orders') : $t('manage_other_orders') }}
                div.button-Aa-small.primary400--text.clickable(@click="openCancelLocalDeliveryDialog = true") {{ $t('cancel_order') }}

        template(v-else)
          v-card-title.pa-4
            template
              v-btn(text icon small @click="closeDialog" height)
                eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
              div.ml-3.h6.primary500--text {{ $t('arrange_shipment') }}

          template(v-if="yezzaShippingError")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-col(align="center")
                div.s1.danger500--text.text-center {{ $t('error_message.unable_to_complete_request') }}

          template(v-else)
            v-card-text.pa-4
              v-window(v-model="step" touchless)

                v-window-item(:value="0")
                  div.p1.basic700--text {{ $t('select_fulfilment_method') }}
                  div.mt-6(style="border:1px solid var(--v-basic400); border-radius: 4px;")
                    div.pa-4
                      div(@click="selectShippingType('courier')")
                        div.d-flex.align-center
                          div.s2.primary--text {{ $t('courier') }}
                          v-spacer
                          eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")
                        div.c1.basic600--text Poslaju, DHL, Pgeon, J&T, SkyNet
                    v-divider.basic400
                    div.pa-4
                      div(@click="selectShippingType('local-delivery')")
                        div.d-flex.align-center
                          div.s2.primary--text {{ $t('local_delivery') }}
                          v-spacer
                          eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")
                        div.c1.basic600--text Lalamove, Grab, Borzo

                v-window-item(:value="1")
                  div.pa-4(style="border:1px solid var(--v-basic400);")
                    div.d-flex.align-center
                      div.mr-4
                        BoxIcon.mb-n2(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].primary }")
                      div.p2.basic700--text {{ $t('total_weight') }}: {{ yezzaShipping.weight }} kg
                      v-spacer
                      a.button-Aa-small.my-auto.info500--text(@click="editWeightDialog = true") {{ $t('edit') }}
                  select-courier.mt-6(v-if="selectedShippingType === 'courier'" :parentRates.sync="rates" :parentSelectedFulfilment.sync="selectedFulfilment")
                  select-local-delivery.mt-6(v-if="selectedShippingType === 'local-delivery'" :parentRates.sync="rates" :parentSelectedFulfilment.sync="selectedFulfilment")
                
                v-window-item(:value="2")
                  credit-alert(:credit="creditBalance" :title="$t('arrange_shipment')" :showTitle="true")
                  
                  div.mt-6(style="border:1px solid var(--v-basic400); border-radius: 4px;")
                    .address(:style="{'background-color' : hastPostcodeError ? $vuetify.theme.themes[$theme].dangerT08 : ''}")
                      div.d-flex.px-4.pt-4(v-if="hastPostcodeError")
                        eva-icon.mr-4(name="alert-triangle-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="14" height="14" style="margin-bottom: -5px")
                        .c2.danger500--text {{ $t('recipient_postcode_invalid') }}
                        v-spacer
                        a.button-Aa-small.my-auto.danger500--text(@click="editRecipientPostcodeDialog = true") {{ $t('edit') }}
                      v-row.pa-4(no-gutters align="center")
                        v-col(cols="6")
                          div.d-flex.align-center(v-if="yezzaShipping.sender_address")
                            eva-icon.mr-4(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -5px")
                            div.p2.basic700--text(v-if="selectedShippingType === 'local-delivery'") {{ yezzaShipping.sender_address.address_1 }} {{ yezzaShipping.sender_address.address_2 ? ', ' + yezzaShipping.sender_address.address_2 : '' }}
                            div(v-else-if="selectedShippingType === 'courier'")
                              div.p2.basic700--text {{ yezzaShipping.sender_address.postcode }}
                              div.p2.basic700--text {{ yezzaShipping.sender_address.city }}
                        v-col(cols="6")
                          div.d-flex.align-center(v-if="yezzaShipping.receiver_address")
                            eva-icon.mr-4(name="arrow-forward-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -5px")
                            div.p2.basic700--text(v-if="selectedShippingType === 'local-delivery'") {{ yezzaShipping.receiver_address.address_1 }} {{ yezzaShipping.receiver_address.address_2 ? ', ' + yezzaShipping.receiver_address.address_2 : '' }}
                            div(v-else-if="selectedShippingType === 'courier'")
                              div.p2.basic700--text {{ yezzaShipping.receiver_address.postcode }}
                              div.p2.basic700--text {{ yezzaShipping.receiver_address.city }}
                    v-divider.basic400

                    .parcel-weight
                      div.d-flex.align-center.pa-4
                        div.mr-4
                          BoxIcon.mb-n1(size="18" :style="{ 'color': $vuetify.theme.themes[$theme].primary }")
                        div.p2.basic700--text {{ $t('total_weight') }}: {{ yezzaShipping.weight }} kg
                        v-spacer
                        a.button-Aa-small.my-auto.info500--text(@click="editWeightDialog = true") {{ $t('edit') }}
                    v-divider.basic400

                    .shipping-rates
                      div.d-flex.align-center.pa-4(v-if="yezzaShipping.fulfilment")
                        div(style="width: 72px" align="center")
                          v-img(:src="yezzaShipping.fulfilment.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                        div.pl-2
                          div.p2.basic700--text {{ yezzaShipping.fulfilment.meta_data.delivery_time || yezzaShipping.fulfilment.title }}
                          div.p2.basic700--text.text-capitalize {{ yezzaShipping.fulfilment.meta_data.service_type }}
                        v-spacer
                        div(align="right")
                          a.button-Aa-small.my-auto.info500--text(@click="editShippingDialog = true") {{ $t('edit') }}
                          div.p2.basic700--text {{ yezzaShipping.fee | displayPrice }}

                      div.pa-4(v-else-if="yezzaShipping.lead_selection" style="background-color: var(--v-dangerT08);")
                        div.d-flex.align-center
                          eva-icon.mr-2(name="alert-triangle-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="18" height="18" style="margin-bottom: -5px")
                          div.c2.danger500--text Selected {{ yezzaShipping.lead_selection.shipping_type === 'courier' ? 'courier' : 'local delivery' }} {{ $t('unavailable') }}
                          v-spacer
                          div(align="right")
                            a.button-Aa-small.my-auto.danger500--text(@click="editShippingDialog = true") {{ $t('edit') }}
                        div.d-flex.align-center.mt-3
                          div(style="width: 72px" align="center")
                            v-img(:src="yezzaShipping.lead_selection.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
                          div.pl-2
                            div.p2.basic600--text(v-if="yezzaShipping.lead_selection.delivery_time") {{ yezzaShipping.lead_selection.delivery_time }}
                            div.p2.basic600--text(v-else-if="yezzaShipping.fulfilment") {{ yezzaShipping.fulfilment.title }}
                            div.p2.basic600--text(v-else) {{ yezzaShipping.lead_selection.shipping_name }}
                            div.p2.basic600--text.text-capitalize {{ yezzaShipping.lead_selection.service_type }}
                          v-spacer
                          div(align="right")
                            div.p2.basic600--text {{ yezzaShipping.fee | displayPrice }}
                    v-divider.basic400

                    .delivery-time
                      div.d-flex.align-center.pa-4
                        eva-icon.mr-4(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="18" height="18" style="margin-bottom: -5px")
                        template(v-if="selectedShippingType === 'courier'")
                          div.p2.basic700--text.text-capitalize(v-if="yezzaShipping.fulfilment") {{ yezzaShipping.fulfilment.meta_data.service_type }}
                            span.ml-1(v-if="yezzaShipping.delivery_at") | {{ yezzaShipping.delivery_at | displayDate }}
                            span.ml-1.c2.danger500--text(v-else) {{ $t('please_select_delivery_date') }}
                          v-spacer
                          a.button-Aa-small.my-auto.info500--text(@click="editDateDialog = true") {{ $t('edit') }}
                        template(v-else)
                          div.p2.basic700--text {{ $t('pick_up') }}
                            span.ml-1(v-if="yezzaShipping.delivery_at") | {{ yezzaShipping.delivery_at | convertServerDate }}
                            span.ml-1(v-else) ASAP
                          v-spacer
                          a.button-Aa-small.my-auto.info500--text(@click="editDateTimeDialog = true") {{ $t('edit') }}

                  template(v-if="showPreferredService")
                    y-checkbox.mt-5(v-model="preferredService" :color="$vuetify.theme.themes[$theme].info500")
                      template(v-slot:label)
                        div.c1.primary--text {{ $t('save_as_preferred_service') }}
                  
                  .p2.basic600--text.mt-2 {{ $t('having_issues') }}?&nbsp;
                    span.s1.basic600--text.clickable(style="text-decoration: underline;" @click="openTypeFormDialog = true") {{ $t('tell_us_about_it') }}

            v-card-actions.px-4(v-if="step !== 0")
              v-spacer
              v-btn(v-if="rates.length === 0" color="transparent" text @click="closeDialog")
                .button-Aa-medium.primary400--text {{ $t('cancel') }}
              v-btn(v-else color="transparent" text @click="step--")
                .button-Aa-medium.primary400--text {{ $t('back') }}
              v-btn.button-AA-medium(v-if="step === 1" color="info500" depressed height="40" @click="saveFulfilment" :loading="isLoading" :dark="Boolean(selectedFulfilment)" :disabled="!selectedFulfilment")
                div.mx-2(:class="{ 'basic100--text': selectedFulfilment }") {{ $t('proceed_to_review') }}
              v-btn.button-AA-medium(v-if="step === 2" color="info500" depressed height="40" @click="payNow" :loading="isLoading" :dark="!disabledPaynow" :disabled="disabledPaynow")
                div.mx-2(:class="{ 'basic100--text': !disabledPaynow }") {{ $t('pay_now') }}
        
    .modal
      confirm-cancel-local-delivery(v-if="openCancelLocalDeliveryDialog" :open.sync="openCancelLocalDeliveryDialog" :orderNumber="orderNumber" @cancelOrder="cancelOrder")
      cancel-local-delivery-error(v-if="openCancelOrderErrorDialog" :open.sync="openCancelOrderErrorDialog" :error="errorCancel" @close="closeCancelOrderError")
      edit-weight(v-if="editWeightDialog" :open.sync="editWeightDialog" :parentYezzaShipping.sync="yezzaShipping" @updateWeight="fetchRates()")
      edit-shipping(v-if="editShippingDialog" :open.sync="editShippingDialog" :selectedShippingType="selectedShippingType" :lead="lead" :parentSelectedFulfilment.sync="selectedFulfilment" :parentYezzaShipping.sync="yezzaShipping")
      edit-date-time(v-if="editDateTimeDialog" :open.sync="editDateTimeDialog" :parentYezzaShipping.sync="yezzaShipping")
      edit-date(v-if="editDateDialog" :open.sync="editDateDialog" :parentYezzaShipping.sync="yezzaShipping")
      edit-postcode(v-if="editRecipientPostcodeDialog" :open.sync="editRecipientPostcodeDialog" :parentYezzaShipping.sync="yezzaShipping" :lead="lead" @updated="handleUpdatePostcode")
      //- tracking-view(v-if="openTrackingViewDialog && arrangedShipping" :open.sync="openTrackingViewDialog" :link="arrangedShipping.meta_data.tracking_no")
      TypeFormView(v-if="openTypeFormDialog" :open.sync="openTypeFormDialog" :link="typeFormUrl")
</template>

<script>
import { DateTime } from 'luxon'
import { mapState, mapGetters, mapActions } from 'vuex'
import SelectCourier from '@/components/dialogs/yezzashipping/SelectCourier.vue'
import SelectLocalDelivery from '@/components/dialogs/yezzashipping/SelectLocalDelivery.vue'
import EditWeight from '@/components/dialogs/yezzashipping/EditWeight.vue'
import EditShipping from '@/components/dialogs/yezzashipping/EditShipping.vue'
import EditDateTime from '@/components/dialogs/yezzashipping/EditDateTime.vue'
import EditDate from '@/components/dialogs/yezzashipping/EditDate.vue'
// NOTE: Not in use due to issue with unresponsive button in iframe
// import TrackingView from '@/components/dialogs/yezzashipping/TrackingView.vue'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'
import EditPostcode from '@/components/dialogs/yezzashipping/EditPostcode.vue'
import TypeFormView from '@/components/dialogs/TypeFormView.vue'
import ConfirmCancelLocalDelivery from '@/components/dialogs/yezzashipping/ConfirmCancelLocalDelivery.vue'
import CancelLocalDeliveryError from '@/components/dialogs/yezzashipping/CancelLocalDeliveryError.vue'

export default {
  name: 'ArrangeShipment',
  components: { CreditAlert, SelectCourier, SelectLocalDelivery, EditWeight, EditShipping, EditDateTime, EditDate, EditPostcode, TypeFormView, ConfirmCancelLocalDelivery, CancelLocalDeliveryError },
  props: ['open', 'parentLead', 'parentYezzaShipping', 'skipArrangingRiderScene'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    editWeightDialog: false,
    editShippingDialog: false,
    editDateTimeDialog: false,
    editDateDialog: false,
    openTrackingViewDialog: false,
    editRecipientPostcodeDialog: false,
    rates: [],
    step: 0,
    selectedShippingType: null,
    selectedFulfilment: null,
    arrangedShipping: null,
    yezzaShippingError: false,
    arrangeSuccessful: false,
    preferredService: false,
    showPreferredService: false,
    hastPostcodeError: false,
    openTypeFormDialog: false,
    isReady: false,
    arrangingRider: false,
    openCancelLocalDeliveryDialog: false,
    toOngoingDialogCountdown: null,
    errorCancel: null,
    openCancelOrderErrorDialog: false
  }),
  computed: {
    ...mapState('riders', {
      ongoingData: state => state.ongoing,
      statusCheckIntervalTime: state => state.intervalTime
    }),
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    containerWidth() {
      if (this.isReady && this.$refs.container) {
        return this.$refs.container.clientWidth - 18
      }
      return 540
    },
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    yezzaShipping: {
      get() {
        return this.parentYezzaShipping
      },
      set(newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    },
    disabledPaynow() {
      if (this.creditBalance < this.yezzaShipping.fee) {
        return true
      } else if (this.hastPostcodeError) {
        return true
      }
      if (this.yezzaShipping.fulfilment && this.yezzaShipping.fee && this.yezzaShipping.weight) {
        if ((this.yezzaShipping.fulfilment.meta_data.shipping_type === 'courier' && this.yezzaShipping.delivery_at) || this.yezzaShipping.fulfilment.meta_data.shipping_type === 'local-delivery') {
          return false
        }
      }
      return true
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
    typeFormUrl() {
      return `https://yezzaio.typeform.com/to/t348E6bz#id=${this.company.id}`
    },
    typeFormRateUrl() {
      return `https://yezzaio.typeform.com/to/Xiks3TOn#id=${this.company.id}`
    },
    orderNumber() {
      return `#${this.lead.rid}`
    },
    hasOtherOngoingData() {
      if (this.selectedShippingType === 'local-delivery') {
        return this.ongoingData.filter(data => data.id !== this.yezzaShipping.id).length > 0
      }
      return false
    }
  },
  watch: {
    rates: {
      deep: true,
      handler(val) {
        if (val.length > 0) {
          if (this.step === 0) {
            if (!val.map(m => m.meta_data.shipping_type).includes('courier')) {
              this.selectedShippingType = 'local-delivery'
              this.step = 1
            } else if (!val.map(m => m.meta_data.shipping_type).includes('local-delivery')) {
              this.selectedShippingType = 'courier'
              this.step = 1
            } else {
              if (this.lead.shipping.fulfilment_type === 'courier') {
                this.selectedShippingType = 'courier'
                this.step = 1
              } else if (this.lead.shipping.fulfilment_type === 'local_delivery') {
                this.selectedShippingType = 'local-delivery'
                this.step = 1
              }
            }
          }
        }
      }
    },
    preferredService() {
      this.updatePreferredService()
    }
  },
  mounted() {
    this.isReady = true
    if (this.yezzaShipping.fulfilment) {
      this.selectedShippingType = this.yezzaShipping.fulfilment.meta_data.shipping_type
      this.selectedFulfilment = this.yezzaShipping.fulfilment
      this.step = 2
    } else if (this.yezzaShipping.lead_selection) {
      this.checkLeadSelection()
    } else {
      this.checkPreferredShipper()
    }
  },
  beforeDestroy() {
    if (this.toOngoingDialogCountdown) {
      clearTimeout(this.toOngoingDialogCountdown)
    }
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    checkLeadSelection() {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/rates/${this.lead.pid}`)
        .then(resp => {
          if (resp.data && resp.data.length > 0) {
            let filteredCustomerSelection = resp.data.filter(f => f.meta_data && f.meta_data.service_id === this.yezzaShipping.lead_selection.service_id)
            if (filteredCustomerSelection.length > 0 && !filteredCustomerSelection[0].error) {
              let data = {
                fulfilment: { ...filteredCustomerSelection[0] }
              }
              if (filteredCustomerSelection[0].shipping_method === 'ys_courier') {
                data['delivery_at'] = this.getTomorrowDate()
              }
              this.$axios.patch(`/shipping/yezzashipping/${this.yezzaShipping.id}`, data)
                .then(resp2 => {
                  this.yezzaShipping = resp2.data
                  this.selectedFulfilment = resp2.data.fulfilment
                  this.selectedShippingType = resp2.data.fulfilment.meta_data.shipping_type
                  this.step = 2
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                })
                .finally(() => {
                  this.isFetching = false
                })
            } else {
              this.selectedShippingType = this.yezzaShipping.lead_selection.shipping_type
              this.step = 2
              this.isFetching = false
            }
          } else {
            this.yezzaShippingError = true
            this.isFetching = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isFetching = false
        })
    },
    checkPreferredShipper () {
      if (this.lead.shipping && this.lead.shipping.manual_shipping) {
        this.isFetching = true
        this.$axios.get(`/shipping/settings/${this.company.slug}/manual_shippings/${this.lead.shipping.manual_shipping}`)
          .then(resp => {
            if (resp.data.preferred_shipper) {
              let preferredShipper = resp.data.preferred_shipper
              this.$axios.get(`/shipping/yezzashipping/rates/${this.lead.pid}`)
                .then(resp2 => {
                  if (resp2.data && resp2.data.length > 0) {
                    let filteredCustomerSelection = resp2.data.filter(f => f.meta_data.service_id === preferredShipper)
                    if (filteredCustomerSelection.length > 0 && !filteredCustomerSelection[0].error) {
                      let data = {
                        fulfilment: { ...filteredCustomerSelection[0] }
                      }
                      if (filteredCustomerSelection[0].shipping_method === 'ys_courier') {
                        data['delivery_at'] = this.getTomorrowDate()
                      }
                      this.$axios.patch(`/shipping/yezzashipping/${this.yezzaShipping.id}`, data)
                        .then(resp3 => {
                          this.yezzaShipping = resp3.data
                          this.selectedFulfilment = resp3.data.fulfilment
                          this.selectedShippingType = resp3.data.fulfilment.meta_data.shipping_type
                          this.step = 2
                        })
                        .catch(() => {
                          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                        })
                        .finally(() => {
                          this.isFetching = false
                        })
                    } else {
                      this.rates = resp2.data
                      this.selectedShippingType = resp.data.fulfilment_type === 'courier' ? 'courier' : 'local-delivery'
                      this.step = 1
                      this.isFetching = false
                    }
                  } else {
                    this.yezzaShippingError = true
                    this.isFetching = false
                  }
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                  this.yezzaShippingError = true
                  this.isFetching = false
                })
            } else {
              this.showPreferredService = true
              this.fetchRates()
            }
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            this.yezzaShippingError = true
            this.isFetching = false
          })
      } else {
        this.yezzaShippingError = true
      }
    },
    fetchRates() {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/rates/${this.lead.pid}`)
        .then(resp => {
          if (resp.data && resp.data.length > 0) {
            this.selectedFulfilment = null
            this.selectedShippingType = this.lead.shipping && !this.lead.shipping.fulfilment_type ? null : this.lead.shipping.fulfilment_type === 'courier' ? 'courier' : 'local-delivery'
            this.step = 1
            this.rates = resp.data
          } else {
            this.yezzaShippingError = true
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    selectShippingType(type) {
      this.selectedShippingType = type
      this.step++
    },
    saveFulfilment() {
      this.isLoading = true
      let data = { fulfilment: this.selectedFulfilment }
      if (this.selectedShippingType === 'courier') {
        data['delivery_at'] = this.getTomorrowDate()
      }
      this.$axios.patch(`/shipping/yezzashipping/${this.yezzaShipping.id}`, data)
        .then(resp => {
          this.yezzaShipping = resp.data
          this.step = 2
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    payNow() {
      this.isLoading = true
      this.isFetching = true
      let data = {
        shipping_method: this.yezzaShipping.fulfilment.shipping_method,
        shippings: [this.yezzaShipping.shipping]
      }
      this.$axios.post('/shipping/yezzashipping/submit_order', data)
        .then(async resp => {
          if (resp.data.failed_order === 0) {
            if (this.selectedShippingType === 'local-delivery') {
              this.$store.commit('riders/updateRefetchOneOrder', this.lead.pid)
              // Trigger rider status first for updating rider vuex store data
              await this.checkRiderStatus()
              if (this.skipArrangingRiderScene) {
                this.$emit('setOngoingInterval')
                this.toOngoingDialog()
              } else {
                this.toOngoingDialogCountdown = setTimeout(() => {
                  this.toOngoingDialog()
                }, 5000)
              }
              this.arrangingRider = true
              this.fetchCompany()
            } else {
              this.arrangedShipping = resp.data.orders[0]
              this.arrangeSuccessful = true
              this.fetchCompany()
            }
          } else {
            if (resp.data.orders[0].ext_remark.includes(this.yezzaShipping.receiver_address.postcode)) {
              this.hastPostcodeError = true
            }
            this.showMessage(['error', this.$t('error_message.unable_to_submit_order')])
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.detail) {
            this.showMessage(['error', e.response.data.detail])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
          this.isFetching = false
        })
    },
    checkRiderStatus() {
      const params = { company: this.company.id }
      return this.$axios.get('/shipping/yezzashipping/ongoing', { params })
        .then(resp => {
          this.$store.commit('riders/updateOngoingData', resp.data)
        })
        .catch(() => {})
    },
    cancelOrder() {
      this.$axios.get(`/shipping/yezzashipping/${this.yezzaShipping.id}/cancel`)
        .then(() => {
          this.$store.commit('riders/updateRefetchOneOrder', this.lead.pid)
          // close dialog
          setTimeout(() => {
            this.showMessage(['success', this.$t('success_message.order_cancelled')])
            this.closeDialog()
          }, 1000)
          this.fetchCompany()
        })
        .catch(error => {
          // Handling error from error code
          if (error.response) {
            const { data } = error.response
            if (data.code) {
              this.errorCancel = data
              this.openCancelOrderErrorDialog = true
              this.openCancelLocalDeliveryDialog = false
              this.$store.commit('riders/updateRefetchOneOrder', this.lead.pid)
              return
            }
          }
          // Everything else
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.closeDialog()
        })
    },
    closeCancelOrderError() {
      if (this.errorCancel.code === '444004') {
        this.checkLeadSelection()
      }
      if (this.errorCancel.code === '444003') {
        this.$emit('refetchYezzaShipping')
      }
      this.closeDialog()
    },
    updatePreferredService() {
      if (!this.yezzaShipping.fulfilment) {
        return
      }
      let prefship = null
      if (this.preferredService) {
        prefship = this.yezzaShipping.fulfilment.meta_data.service_id
      }
      this.$axios.patch(`/shipping/settings/${this.company.slug}/manual_shippings/${this.lead.shipping.manual_shipping}`, { preferred_shipper: prefship }).catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
    },
    displayArrangeOnDate(value) {
      const date = DateTime.fromFormat(value, 'yyyy-MM-dd hh:mm:ss')
      return `${date.toFormat('dd/MM/yyyy')} at ${date.toFormat('hh:mma')}`
    },
    handleUpdatePostcode() {
      this.hastPostcodeError = false
      this.$axios.get(`/shipping/yezzashipping/${this.yezzaShipping.id}`)
        .then(resp => {
          this.yezzaShipping = resp.data
        })
        .catch(() => {})
    },
    shareToWA(tracking_no) {
      window.open(`https://api.whatsapp.com/send?text=${tracking_no}&phone=${this.yezzaShipping.receiver_address.phone}`)
    },
    copyTrackingNo() {
      this.showMessage(['success', this.$t('success_message.tracking_number_copied_clipboard')])
    },
    copyTrackingLink() {
      this.showMessage(['success', this.$t('success_message.tracking_link_copied_clipboard')])
    },
    shareTrackingLinkToWA(shipping_name, tracking_no) {
      const message = `Hi, we have arranged your delivery with ${shipping_name}. You can track its real-time location here: ${encodeURIComponent(tracking_no)}. Download Zoo to get notifications: ${encodeURIComponent('http://onelink.to/hzsjsu')}`
      window.open(`https://api.whatsapp.com/send?text=${message}&phone=${this.yezzaShipping.receiver_address.phone}`)
    },
    clickDownloadAWB(link) {
      if (this.$isMobile) {
        window.open(link)
      } else {
        location.href = link
      }
    },
    fetchCompany() {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    closeAllDialogs() {
      this.$emit('closeDialog')
      this.showModal = false
    },
    closeDialog() {
      this.$emit('updateYsId', this.yezzaShipping.id)
      this.showModal = false
    },
    toOngoingDialog() {
      this.$store.commit('riders/updateRefetchOneOrder', this.lead.pid)
      this.openOngoingDialog()
    },
    openOngoingDialog() {
      this.closeAllDialogs()
      this.$store.commit('riders/updateOpenOngoingDialog', true)
    },
    finishArranging() {
      this.$emit('refetchLead')
      this.showModal = false
    },
    getTomorrowDate() {
      const today = new Date()
      let tomorrow = new Date(today.setDate(today.getDate() + 1))
      const date = DateTime.fromISO(tomorrow.toISOString())
      return `${date.toFormat('yyyy-MM-dd')} 08:00:00`
    },
    openTrackingLink () {
      window.open(this.arrangedShipping.meta_data.tracking_no, '_blank')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "arranging_shipment": "Arranging shipment",
    "please_do_not_refresh": "Please do not refresh this page",
    "arrangement_successful": "Arrangement successful",
    "your_delivery_are_shown": "Your delivery arrangement for Order #{id} are as shown below",
    "refer_link_real_time": "Refer link for real-time tracking",
    "copy_tracking_no": "Copy tracking no.",
    "share_tracking_customer": "Share tracking no. with customer",
    "download_air_waybill": "Download air waybill",
    "copy_tracking_link": "Copy tracking link",
    "view_real_time_tracking": "View real-time tracking",
    "tracking_data_not_ready": "Tracking data is not ready yet, please check it back later.",
    "arranged_on": "Arranged on",
    "select_fulfilment_method": "Select fulfilment method for this order",
    "unavailable": "unavailable",
    "save_as_preferred_service": "Save as preferred service for this manual rate",
    "having_issues": "Having issues",
    "tell_us_about_it": "Tell us about it.",
    "proceed_to_review": "Proceed to review",
    "recipient_postcode_invalid": "Recipient postcode is invalid",
    "finding_rider": "Finding you a rider",
    "hold_on": "Hold tight. This might take a while.",
    "view_all_ongoing_orders": "view all ongoing orders",
    "manage_other_orders": "manage other orders",
    "cancel_order": "Cancel this order"
  },
  "id": {
    "arranging_shipment": "Mengatur pengiriman",
    "please_do_not_refresh": "Tolong jangan segarkan halaman ini",
    "arrangement_successful": "Pengaturan berhasil",
    "your_delivery_are_shown": "Pengaturan pengiriman kamu untuk Pesanan #{id} adalah seperti yang ditunjukkan di bawah ini",
    "refer_link_real_time": "Tautan rujukan untuk pelacakan waktu nyata",
    "copy_tracking_no": "Salin nomor pelacakan.",
    "share_tracking_customer": "Bagikan nomor pelacakan dengan pelanggan",
    "download_air_waybill": "Unduh air waybill",
    "copy_tracking_link": "Salin tautan pelacakan",
    "view_real_time_tracking": "Lihat pelacakan waktu nyata",
    "tracking_data_not_ready": "Data pelacakan belum siap, silakan periksa kembali nanti.",
    "arranged_on": "Diatur pada",
    "select_fulfilment_method": "Pilih metode pemenuhan untuk pesanan ini",
    "unavailable": "tidak tersedia",
    "save_as_preferred_service": "Simpan sebagai layanan pilihan untuk tarif manual ini",
    "have_issues": "Memiliki masalah",
    "tell_us_about_it": "Beri tahu kami tentang hal itu.",
    "proceed_to_review": "Lanjutkan ke peninjauan",
    "recipient_postcode_invalid": "Kode pos penerima tidak valid",
    "finding_rider": "Menemukan pengendara untuk kamu",
    "hold_on": "Pegang erat-erat. Ini mungkin memakan waktu cukup lama.",
    "view_all_ongoing_orders": "lihat semua pesanan yang sedang berlangsung",
    "manage_other_orders": "kelola pesanan lain",
    "cancel_order": "Batalkan pesanan ini"
  }
}
</i18n>
